module.exports = __webpack_public_path__ + "static/media/BovExo_template_atualizar_animais.926266bf.xlsx";